// test2978
(2978 && 0);
